module.exports = __webpack_public_path__ + "ddd33207c99a824931a99d43b08c7a99.pdf";